class Api {
  constructor(context) {
    this.context = context;
  }

  buildCallURI(endPoint, params = null) {
    for (let key in params) {
      if (params.hasOwnProperty(key)) {
        let regex = new RegExp(`\{${key}\}`);
        endPoint = endPoint.replace(regex, params[key]);
      }
    }

    if (params && params.query) {
      let query = '?';
      for (var prop in params.query) {
        if((!Array.isArray(params.query[prop]) && params.query[prop]) || (Array.isArray(params.query[prop]) && params.query[prop].length)) {
          if (Array.isArray(params.query[prop])) {
            params.query[prop].forEach((element, index) => {
              query += `${prop}[${index}]=${element}&`;
            });
          } else {
            query += `${prop}=${params.query[prop]}&`;
          }
        }
      }
      endPoint += query.substring(0, query.length - 1);
    }
    return endPoint;
  }

  request(route, params = null, body = null) {
    const endPoint = route.endPoint;
    switch (route.method) {
      case 'GET':
        return this.context.$axios.$get(this.buildCallURI(endPoint, params));
      case 'POST':
        return this.context.$axios.$post(this.buildCallURI(endPoint, params), body);
      case 'PUT':
        return this.context.$axios.$put(this.buildCallURI(endPoint, params), body);
      case 'DELETE':
        return this.context.$axios.$delete(this.buildCallURI(endPoint, params));
      default:
        return this.context.$axios.$get(this.buildCallURI(endPoint, params));
    }
  }
}

export default function (context, inject) {
  const api = new Api(context);
  inject('api', api);
}
